import { Component, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { DialogBase, OrderCustomerInfo, OrderCustomerModel } from 't4core';

@Component({
    selector: 't4-turbo-customerInfo',
    templateUrl: './CustomerInfo.component.html',
    styleUrls: ['./CustomerInfo.css']
})
export class CustomerInfo extends DialogBase {

    public customerLocationInfo: OrderCustomerInfo = new OrderCustomerInfo();
    public servicePartner: OrderCustomerInfo = new OrderCustomerInfo();
    public repairPartner: OrderCustomerInfo = new OrderCustomerInfo();
    public usedPartner: OrderCustomerInfo = new OrderCustomerInfo();
    public locationInfo: OrderCustomerModel = new OrderCustomerModel();
    public test: string = "";
    @Input() public customerId: number;

    @ViewChild('gmap', {static: true}) gmapElement: ElementRef;

    constructor(el: ElementRef) {

        super("Order");

    }

    ngOnChanges(changes: SimpleChanges) {
        this.retrieveCustomerInfo(this.customerId);
    }

    async retrieveCustomerInfo(customerId: number) {
        var token = this.beginLoad("TO.Order_Overview_Ldr", "Loading location information", null);
        this.customerLocationInfo = await this.Api.get<OrderCustomerInfo>("TurboOrder/GetOrderCustomerInfo", { customerId: customerId });

        this.servicePartner = new OrderCustomerInfo();
        this.repairPartner = new OrderCustomerInfo();
        this.usedPartner = new OrderCustomerInfo();

        if (this.customerLocationInfo.ServicePartnerId) {
            this.servicePartner = await this.Api.get<any>("TurboOrder/GetOrderCustomerInfo", { customerId: this.customerLocationInfo.ServicePartnerId });
        }

        if (this.customerLocationInfo.RepairPartnerId) {
            this.repairPartner = await this.Api.get<any>("TurboOrder/GetOrderCustomerInfo", { customerId: this.customerLocationInfo.RepairPartnerId });
        }

        const usedPartnerId = (this.customerLocationInfo as any).UsedPartner;
        if (usedPartnerId) {
            this.usedPartner = await this.Api.get<any>("TurboOrder/GetOrderCustomerInfo", { customerId: usedPartnerId });
        }

        var pos = new google.maps.LatLng(this.customerLocationInfo.Latitude, this.customerLocationInfo.Longitude);
        this.gmapElement.nativeElement.src = "https://maps.googleapis.com/maps/api/staticmap?center=" + pos.lat() + "," + pos.lng() + "&zoom=10&size=500x500&maptype=roadmap&markers=" + pos.lat() + "," + pos.lng() + "&key=AIzaSyAPITA4UuI9ERN_XiTDXZC1packZFkx-xE";
        this.endLoad(token);
    }
}
